import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { paragraphStyle } from '../P/textStyle';

const iconColors = [
  'white',
  'primary',
  'secondary',
  'danger',
  'success',
  'xDarkgray'
];

const ButtonWrapper = styled(Button)`
  background: ${props => props.theme.colors.white};
  display: flex;
  justify-content: flex-start;
  /* height: 50px; */
  align-items: center;
  padding: 0;

  ${props =>
    props.gray &&
    css`
      /* & span { */
      border: 1px solid ${props => props.theme.colors.gray};
      background: ${props => props.theme.colors.gray};
      /* } */
    `};

  ${props =>
    props.statusColor &&
    css`
      border: 1px solid ${props => props.theme.colors[props.statusColor]};
    `};
`;

const ButtonText = styled.span`
  ${paragraphStyle};
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  text-align: left;

  span {
    font-family: ${props => props.theme.fonts.fontface};
  }

  ${props =>
    props.statusColor !== 'white' &&
    css`
      color: ${props => props.theme.colors[props.statusColor]};
    `};
`;

const InfoText = styled.span`
  ${paragraphStyle};
  display: flex;
  align-items: center;
  padding: 5px 20px;
`;

const StatusWrapper = styled.div`
  background: ${props => props.theme.colors[props.statusColor]};
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  display: flex;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  text-align: center;

  svg {
    width: 100%;
    height: 30px;
  }
`;

function ListIconButton({
  statusColor = iconColors[0],
  statusIcon,
  iconColor,
  label = '',
  info,
  onClick,
  extraLabel = '',
  ...rest
}) {
  return (
    <ButtonWrapper rounded full onClick={onClick} {...rest}>
      <StatusWrapper statusColor={statusColor}>
        <Icon id={statusIcon} fillColor={iconColor} />
      </StatusWrapper>
      <ButtonText bold statusColor={statusColor}>
        {label}
        <span>&nbsp;{extraLabel}</span>
      </ButtonText>
      {info && <InfoText italic>{info}</InfoText>}
    </ButtonWrapper>
  );
}

ListIconButton.propTypes = {
  onClick: PropTypes.func,
  statusColor: PropTypes.oneOf(iconColors),
  statusIcon: PropTypes.string,
  iconColor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  label: PropTypes.string,
  extraLabel: PropTypes.string,
  info: PropTypes.string
};

export default ListIconButton;
